import React from 'react';
import {Row} from "react-flexbox-grid";

export const OverviewBodyOverBudgetProgressBar = () => (
    <Row className='overview-body-over-budget-progress-bar'/>
);